<div class="container pt-3" >
  <div class="row justify-content-sm-center" style="margin-top:4%">
    <p style="color: #E0FFFF;">Effettua l'accesso per partecipare alla tua videolezione privata.
      Ti aspetto in collegamento per scoprire il fitness direttamente a casa tua!</p>
    <div class="col-sm-12 col-md-12">
      <div class="card border-info" style="margin-top:4%; background-color: #112c41; margin-bottom:4%">
        <div class="card-header"  style="background-color: whitesmoke">Login</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 text-center">
              <img src="/assets/p2.jpg" style="width: 150px; length:150px; margin-bottom:4%">
            </div>
            <div class="col-md-8">
              <form>
                <input [(ngModel)]="user.email"  name="email"  type="text" class="form-control mb-2" placeholder="Email" required autofocus>
                <input [(ngModel)]="user.password" name="password"  type="password" class="form-control mb-2" placeholder="Password" required>
                <button class="btn btn-lg btn-primary btn-block mb-1" (click)="login()" type="submit">Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



